import axios from 'axios';
import { cmsUrl } from '../../variables';

export default {
    loadNavs(context) {
        context.commit('loadMainNav');
        context.commit('loadFooterNav');
        axios
            .get(cmsUrl + '/main-nav')
            .then(data => context.commit('loadMainNavSuccess', data.data))
            .catch(err => context.commit('loadMainNavError', err))

        axios
            .get(cmsUrl + '/footer-nav')
            .then(data => context.commit('loadFooterNavSuccess', data.data))
            .catch(err => context.commit('loadFooterNavError', err))

    },

    setSiteHeaderTransparent(context) {
        context.commit('setSiteHeaderMode', 'transparent');
    },
    setSiteHeaderOpaque(context) {
        context.commit('setSiteHeaderMode', 'opaque');
    },

    showSiteFooter(context) {
        context.commit('setSiteFooterVisability', true);
    },
    hideSiteFooter(context) {
        context.commit('setSiteFooterVisability', false);
    },

};